export const servicesSectionTitle = 'Services';
export const servicesSectionSubtitle = 'What i offer';

export const webDevelopmentServices = [
    {
        iconClass: "icon-class-1",
        description: "I will design a modern and functional web application for you.",
    },
    {
        iconClass: "icon-class-2",
        description: "I handle all aspects of the project, from UI/UX design to implementation and testing.",
    },
    {
        iconClass: "icon-class-3",
        description: "My solutions are tailored to your individual needs and requirements.",
    },
    {
        iconClass: "icon-class-4",
        description: "I ensure high-quality code and focus on efficient and scalable development.",
    },
    {
        iconClass: "icon-class-5",
        description: "My applications are responsive and adaptable to various devices and browsers.",
    },
    {
        iconClass: "icon-class-6",
        description: "I also offer support and maintenance after deployment to ensure your application runs smoothly.",
    },
    {
        iconClass: "icon-class-7",
        description: "Trust me, and together we will create an innovative application that meets your expectations.",
    },
];

export const itConsultingServices = [
    {
        iconClass: "icon-class-1",
        description: "I will provide expert IT consulting services tailored to your business needs.",
    },
    {
        iconClass: "icon-class-2",
        description: "I can assist in technology strategy, planning, and implementation.",
    },
    {
        iconClass: "icon-class-3",
        description: "I offer guidance on selecting the right technologies for your projects.",
    },
    {
        iconClass: "icon-class-4",
        description: "I can help you optimize your IT infrastructure for efficiency and cost savings.",
    },
    {
        iconClass: "icon-class-5",
        description: "I provide solutions for security, data management, and IT governance.",
    },
    {
        iconClass: "icon-class-6",
        description: "Trust me to lead your IT initiatives to success and innovation.",
    },
];

export const maintenanceAndSupportServices = [
    {
        iconClass: "icon-class-1",
        description: "I provide ongoing maintenance to keep your systems running smoothly.",
    },
    {
        iconClass: "icon-class-2",
        description: "I offer 24/7 technical support to address any issues or concerns.",
    },
    {
        iconClass: "icon-class-3",
        description: "I can perform regular updates and security patches for your applications.",
    },
    {
        iconClass: "icon-class-4",
        description: "I ensure data backups and disaster recovery planning to protect your data.",
    },
    {
        iconClass: "icon-class-5",
        description: "I offer training and documentation to help your team use the technology effectively.",
    },
    {
        iconClass: "icon-class-6",
        description: "Trust me to provide reliable support for your IT infrastructure and applications.",
    },
];